import { z } from 'zod/mini'

import { insuranceShape, itemShippingShape, mobilePlanShape } from './cart-item'
import { amount, eventValue, itemObject } from './fields'
import { gtmMetadataShape } from './gtm-metadata'
import { itemShape } from './item'
import { nonEmptyString } from './non-empty-string'
import { detailedTradeInDetailsSchema } from './trade-in-details'

const purchaseItemSchema = itemObject({
  ...itemShape,
  ...insuranceShape,
  ...mobilePlanShape,
  ...itemShippingShape,
  // No item-level coupons in Back Market
  coupon: z.string(),
  item_mobile_plan_commitment_months: z.number().check(z.gte(0)),
  item_mobile_plan_monthly_price: amount(),
  // Empty when the item was not bought from a search result
  item_list_id: z.string(),
  item_list_name: z.string(),
})

/** `trackPurchase` pushes the GA4 purchase under the `purchase_back_bone` name. */
export const purchaseSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('purchase_back_bone'),
  payment_id: nonEmptyString(),
  total_gross_margin: z.number(),
  margin_from_seller: z.number(),
  quality_control_fees: z.number().check(z.gte(0)),
  payment_is_installment: z.boolean(),
  has_trade_in: z.boolean(),
  is_referral_order: z.boolean(),
  ecommerce: z.strictObject({
    // Deduplicates purchases in GA4
    transaction_id: nonEmptyString(),
    // trackPurchase falls back to 0
    value: eventValue(),
    tax: amount(),
    shipping: amount(),
    currency: nonEmptyString(),
    // Empty when no promo code was used
    coupon: z.string(),
    customer_type: z.optional(z.enum(['new', 'returning'])),
    // Payment method code, always known on the result page
    payment_type: nonEmptyString(),
    // A completed purchase has at least one item
    items: z.array(purchaseItemSchema).check(z.minLength(1)),
  }),
  trade_in_details: z.optional(
    z.strictObject({
      ...detailedTradeInDetailsSchema.shape,
      // Not formatted by trackPurchase: always a number
      trade_in_price: z.number().check(z.gte(0)),
      // 'qr_code' | 'colissimo' | 'bulle', empty when unknown
      trade_in_shipping_method: z.string(),
    }),
  ),
})
